module.exports = __webpack_public_path__ + "img/hotel.e260fda2.svg";